var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container my-4"},[_c('h1',[_vm._v("Send us a message")]),_c('p',{staticClass:"lead"},[_vm._v("Thank you for contacting us, we appreciate your interest in the Wellsville High School Soccer team and will respond as soon as we can. ")]),_c('br'),_c('ContactForm'),_c('Spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }